import React from "react";
import './Home.css'; // Assuming you have some styles for the Home page

const Home = () => {
  return (
    <div>
   <div className="full-width-section">
  <div className="container responsive-section">
    <div className="text-content">
      <h1>King's Climbs to 31st in world university rankings</h1>
      <p>
        King's has been named the 31st best university in the world and 5th in the UK in the QS World University Rankings 2026.
      </p>
    </div>

    <div className="image-cover-section">
      {/* Background image through CSS; no <img> inside here */}
    </div>
  </div>

</div>
  <div>
    <h1>Study at King's College London</h1>

     <img src="/international.png" alt="Logo"  />
      <img src="/undergraduate.png" alt="Logo"  />
       <img src="/postgraduate.png" alt="Logo"  />
        <img src="/laptop-thin-kcl-1.png" alt="Logo"  />

  </div>

</div>


  );
};

export default Home;
